// extracted by mini-css-extract-plugin
module.exports = {"Container":"LandingPageVideoSection-module--Container--3s2BN","VideoContainer":"LandingPageVideoSection-module--VideoContainer--15WwI"};